var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.729 120h-35.729v90h31.416l30 302h343.584c41.355 0 75-33.645 75-75v-15h-30v-30h30v-45c0-41.355-33.645-75-75-75h-112.461l6.065-62h31.396v-90h-35.729l-30-60h-102.559l-15-60h-86.712v30h63.289l7.5 30h-65.06zm369.271 362h-150c-19.556 0-36.239-12.539-42.43-30.01h234.86c-6.191 17.471-22.874 30.01-42.43 30.01zm15-60h-180v-30h180zm30-75v15h-240v-15c0-24.813 20.187-45 45-45h150c24.813 0 45 20.187 45 45zm-187.604-75h-7.396c-41.355 0-75 33.645-75 75v45h30v30h-30v15c0 16.871 5.603 32.456 15.041 45h-106.457l-27.02-272h206.897zm37.604-92h-270v-30h270zm-54.271-90 15 30h-191.458l15-30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastFood);
export default __webpack_public_path__ + "static/media/fast-food.0dc5d2fe97add5284adedfff6a426d32.svg";
export { ForwardRef as ReactComponent };